import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css';
import './App.css'
import AnimatedRoutes from 'AnimatedRoutes';
import MetaPixelTracker from 'MetaPixelTracker';
function App() {
  return (
    <BrowserRouter>
      <MetaPixelTracker />
      <AnimatedRoutes/>
    </BrowserRouter>
  );
}

export default App;
